export default () => {

    const toggle = document.querySelector('.toggle-button, .toggle-text');
    if(!toggle) return;

    const toggles = [].slice.call(document.querySelectorAll('.toggle-button, .toggle-text'));

    toggles.forEach((toggle) => {
		toggle.addEventListener('click', (e) => {
			const parentFrame = e.currentTarget.parentNode;
            parentFrame.classList.add("hidden");

            if(parentFrame.nextElementSibling){
                parentFrame.nextElementSibling.classList.remove("hidden");
            }
            else{
                parentFrame.previousElementSibling.classList.remove("hidden");
            }
		});
	});

}